export default function (href?: string) {
  const config = useRuntimeConfig()
  return href?.startsWith('/') || href?.startsWith(config.public.appUrl)
}
